import React, { useContext } from 'react';
import cn from 'clsx';
import icons from '@immediate_media/icons';
import { string, node, oneOf } from 'prop-types';
import FormContext from '../../context/FormContext.js';
import FormGroupContext from '../../context/FormGroupContext.js';
import Icon from '../Icon/index.jsx';

/**
 * FormFeedback component.
 */
const FormFeedback = ({
  className,
  name,
  children,
  icon
}) => {
  const {
    feedbackId
  } = useContext(FormGroupContext);
  const {
    errors
  } = useContext(FormContext);
  const errorMsg = errors === null || errors === void 0 ? void 0 : errors[name];
  return /*#__PURE__*/React.createElement("div", {
    id: feedbackId,
    className: cn("form-feedback body-copy-extra-small body-copy-bold", (children || errorMsg) && 'mt-xxs', className, errorMsg && 'form-feedback--invalid', icon && 'form-feedback--with-icon'),
    role: errorMsg ? 'alert' : null
  }, icon && (errorMsg || children) ? /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    className: "d-inline-flex mr-xxs",
    color: "inherit"
  }) : null, errorMsg || children);
};
FormFeedback.defaultProps = {
  className: null,
  name: null,
  children: null,
  icon: null
};
FormFeedback.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional class names to add to the component root. */
  className: string,
  /** The name of the form element we are providing feedback for. */
  name: string,
  /** Feedback to display if there are no associated errors. */
  children: node,
  /** Icon to display in front of the error message/children */
  icon: oneOf(Object.keys(icons))
} : {};
export default FormFeedback;